import {useEffect} from "react";
import {css} from "@panda/css";

import {IApplication} from "../../../../application/types/IApplication";
import {ISetPreferencesStepPayload} from "../../../../application/types/ISetPreferencesStepPayload";
import {useAppDispatch} from "../../../../store/hooks";
import {useLeadModalConversationFormPriceCheck} from "../../../hooks/use_lead_modal_conversation_form_price_check";
import {setPriceConversationConsultant} from "../../../state/main_lead_slice";
import {getRandomConsultant} from "../../../utils/get_random_consultant";
import {LeadModalPriceConversation} from "./lead_modal_price_conversation/LeadModalPriceConversation";
import {LeadModalCheckPriceStepLoader} from "./LeadModalCheckPriceStepLoader";

interface IProps {
    handleModalClose: () => void;
    handleSetPreferencesStep: (payload: ISetPreferencesStepPayload) => void;
    handleUpdateMainLeadResponse: (sentApplication: IApplication) => void;
    price: number | null;
    storeHash: string;
}

export function LeadModalPriceConversationStep(props: IProps) {
    const {handleModalClose, handleSetPreferencesStep, handleUpdateMainLeadResponse, price, storeHash} = props;

    const dispatch = useAppDispatch();

    const hasPrice = typeof price === "number";

    const checkingPrice = useLeadModalConversationFormPriceCheck(!hasPrice);

    useEffect(() => {
        dispatch(setPriceConversationConsultant(getRandomConsultant()));
    }, []);

    return (
        <div className={conversationFormStep}>
            {checkingPrice ? (
                <LeadModalCheckPriceStepLoader hasPrice={hasPrice} />
            ) : (
                <LeadModalPriceConversation
                    handleModalClose={handleModalClose}
                    handleSetPreferencesStep={handleSetPreferencesStep}
                    handleUpdateMainLeadResponse={handleUpdateMainLeadResponse}
                    price={price}
                    storeHash={storeHash}
                />
            )}
        </div>
    );
}

const conversationFormStep = css({
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",

    md: {
        width: "851px",
        height: "677px"
    }
});
import {useEffect} from "react";
import {css} from "@panda/css";

import {IApplication} from "../../../../application/types/IApplication";
import {ISetPreferencesStepPayload} from "../../../../application/types/ISetPreferencesStepPayload";
import {useAppDispatch} from "../../../../store/hooks";
import {useLeadModalConversationFormPriceCheck} from "../../../hooks/use_lead_modal_conversation_form_price_check";
import {setPriceConversationConsultant} from "../../../state/main_lead_slice";
import {getRandomConsultant} from "../../../utils/get_random_consultant";
import {LeadModalPriceConversation} from "./lead_modal_price_conversation/LeadModalPriceConversation";
import {LeadModalCheckPriceStepLoader} from "./LeadModalCheckPriceStepLoader";

interface IProps {
    handleModalClose: () => void;
    handleSetPreferencesStep: (payload: ISetPreferencesStepPayload) => void;
    handleUpdateMainLeadResponse: (sentApplication: IApplication) => void;
    price: number | null;
    storeHash: string;
}

export function LeadModalPriceConversationStep(props: IProps) {
    const {handleModalClose, handleSetPreferencesStep, handleUpdateMainLeadResponse, price, storeHash} = props;

    const dispatch = useAppDispatch();

    const hasPrice = typeof price === "number";

    const checkingPrice = useLeadModalConversationFormPriceCheck(!hasPrice);

    useEffect(() => {
        dispatch(setPriceConversationConsultant(getRandomConsultant()));
    }, []);

    return (
        <div className={conversationFormStep}>
            {checkingPrice ? (
                <LeadModalCheckPriceStepLoader hasPrice={hasPrice} />
            ) : (
                <LeadModalPriceConversation
                    handleModalClose={handleModalClose}
                    handleSetPreferencesStep={handleSetPreferencesStep}
                    handleUpdateMainLeadResponse={handleUpdateMainLeadResponse}
                    price={price}
                    storeHash={storeHash}
                />
            )}
        </div>
    );
}

const conversationFormStep = css({
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",

    md: {
        width: "851px",
        height: "677px"
    }
});
